export default __webpack_public_path__ + "static/medvision_logo-570b04bbaa59e804b0dc6ac5a7bc212c.svg";